// extracted by mini-css-extract-plugin
module.exports = {"amenities__amenitiesItem":"amenities__amenitiesItem-1CmdE","amenities__amenitiesItemUnavailable":"amenities__amenitiesItemUnavailable-zIyGu"};